import React from 'react'

export default function NotFound() {
    return (
        <div>
            ERROR PAGE NOT FOUND 404
        </div>
    )
}
